<template>

  <section class="content">

    <modal title="Supprimer un materiel"
           v-on:close="doCloseAnyModals"
           v-if="deleteModal === true">
      <materiel-delete slot="body"
                       v-on:close="doCloseAnyModals"
                       :materiel="materiel"></materiel-delete>
    </modal>

    <modal title="Modifier un matériel"
           v-on:close="doCloseAnyModals"
           v-if="updateModal === true">
      <materiel-form slot="body"
                     v-on:close="doCloseAnyModals"
                     :update-materiel="materiel"></materiel-form>
    </modal>

    <modal title="Ajouter un matériel"
           v-on:close="doCloseAnyModals"
           v-if="createModal === true">
      <materiel-form slot="body"
                     v-on:close="doCloseAnyModals"></materiel-form>
    </modal>

    <section class="content-toolbar">
      <div class="btn btn-primary"
           v-on:click="clickCreate()">Ajouter un matériel</div>
    </section>

    <materiel-list v-on:delete="clickDelete"
                   v-on:edit="clickEdit">
    </materiel-list>

  </section>
  
</template>

<script>
import MaterielList from './MaterielList'
import MaterielDelete from './MaterielDelete'
import MaterielForm from './MaterielForm'
import Modal from '../commons/Modal'

export default {
  components: {
    MaterielList,
    MaterielDelete,
    MaterielForm,
    Modal,
  },
  data: function () {
    return {
      deleteModal: false,
      updateModal: false,
      createModal: false,
      materiel: null,
    }
  },
  methods: {
    clickDelete: function (materiel) {
      this.materiel = materiel
      this.deleteModal = true
    },
    clickEdit: function (materiel) {
      this.materiel = materiel
      this.updateModal = true
    },
    clickCreate: function () {
      this.createModal = true
    },
    doCloseAnyModals: function () {
      this.deleteModal = false
      this.updateModal = false
      this.createModal = false
    },
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Materiel.vue?4ef6731d